import React, { useContext, useEffect, useState } from 'react'
import { APPS } from '../../../constants';
import { FollowUpTicketsContext } from '../../../context/FollowUpTicketsContext';
import { DateUtil } from '../../../utils/date';
import Tooltip from '../../../components/Tooltip';
import { useTranslation } from 'react-i18next';

export default function TicketProfileCard({ data }) {

    const { t } = useTranslation();
    const [isSelected, setIsSelected] = useState(false);
    const {ticketSelected, setTicketSelected}= useContext(FollowUpTicketsContext);
    const onlyNumbers = /\D+/g;
    const handleToggleSelection = () => {
        if(ticketSelected?.account_key_client != data.account_key_client){
            setTicketSelected(data);
        }
    };

    const getTitleTooltip = () => {
        switch (data._status_ticket.toUpperCase()) {
            case 'TSRA':
                return 'TICKETS SIN RESPUESTA DEL AGENTE';
            case 'TSRC':
                return 'TICKETS SIN RESPUESTA DEL CLIENTE';
            case 'TSA':
                return 'TICKETS SIN ASIGNACIÓN'
            default:
                return data._status_ticket.toUpperCase()
        }
    }

    useEffect(()=>{
        setIsSelected(ticketSelected?.account_key_client === data.account_key_client);
    },[ticketSelected])
    
    const select = (isSelected) ? 'selected-card' : 'tracking-ticket'

    return (
        <div className={`card shadow-none rounded-0 border-0 border-bottom rounded-0 ${select}`} onClick={handleToggleSelection}>
            <div className='p-3 d-flex'>
                {(() => {
                    switch (data.app.toUpperCase()) {
                        case APPS.WHATSAPP_BUSINESS:
                            return <span className="avatar avatar-circle px-0"><img className="avatar-img" src="/assets/img/waBusiness.jpg" alt="Image Description" /></span>;
                        case APPS.WHATSAPP_STANDAR:
                            return <span className="avatar avatar-circle px-0"><img className="avatar-img" src="/assets/img/waStandard.jpg" alt="Image Description" /></span>;
                        case APPS.SMS:
                            return <span className="avatar avatar-circle px-0"><img className="avatar-img" src="/assets/img/smsLogo.jpg" alt="Image Description" /></span>;
                        case APPS.RCS:
                            return <span className="avatar avatar-circle px-0"><img className="avatar-img" src="/assets/img/rcsLogo.jpg" alt="Image Description" /></span>;
                        default:
                            return <div></div>;
                    }
                })()}
                <div className='flex-grow-1 px-2'>
                    <h5 className="mbottom-6">{data.name_client}</h5>
                    <p className='m-0 p-0 lh-11'>{data.chat_number.replace(onlyNumbers, '')}</p>
                    {data.assing_to.toLowerCase() !=='sin asignar' ? (
                        <p className='mt-2 mbottom-6'>{data.assing_to}</p>
                    ) : (
                        <span className="badge bg-danger badge-sm mt-2 font-10 mbottom-6">{t('follow-up.tickets.profile.tsa-status')}</span>
                    )}
                    {data.base_name ? <span className="badge bg-secondary me-1 mb-1">{data.base_name}</span> : null}
                    <div>
                        <Tooltip title={getTitleTooltip()} className='width-fit-content d-inline-block'>
                            <span className="badge bg-secondary me-1">{data._status_ticket.toUpperCase()}</span>
                        </Tooltip>
                        
                        {data.label_ticket ? <span className="badge bg-info">{data.label_ticket}</span> : <span className="badge bg-danger">{t('follow-up.tickets.profile.no-label')}</span>}
                    </div>
                </div>
                    <p className="">{DateUtil.timeFormat(data.date_last_message)}</p>
            </div>
        </div>
    )
}
